import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import './MLIconLink.scss';

const MLIconLink = ({ children, className, color = 'darkest-gray', icon, ...props }) => {
    const classes = classnames('ml-icon-link', 'ml-link', className);

    const iconName = `${icon}-${color}.svg`;
    const style = {
        backgroundImage: `url(/img/icons/${iconName})`,
    };

    return (
         
        <a
            {...props}
            className={classes}
            style={style}
        >
            {children}
        </a>
    );
};

MLIconLink.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    color: PropTypes.oneOf([
        'black',
        'blue1',
        'blue2',
        'dark-gray',
        'darkest-gray',
        'gray',
        'white',
    ]),
    icon: PropTypes.string.isRequired,
};

export default MLIconLink;
